import { PudoLocation } from '@pperform/pp-data-mappers';
import APIError from 'exceptions/APIError';
import AppError from 'exceptions/AppError';
import { getPudoLocationFetcher } from '../fetchers/pudoLocation.fetcher';

export const getShipmentCollectionPoint = async (
  organizationId: number,
  shipmentPk: number,
) => {
  try {
    const { data } = await getPudoLocationFetcher(organizationId, shipmentPk);
    return PudoLocation.fromApiData(data[0]);
  } catch (_) {
    return null;
  }
};
